import { FC } from 'react';
import SubscriptionCard from './SubscriptionCard';
import { PricePlan } from 'lib/type';

interface ManageSubscriptionProps {
    productType?: string;
    pricePlans: PricePlan[];
}

const ManageSubscription: FC<ManageSubscriptionProps> = ({
    productType,
    pricePlans,
}) => {
    return (
        <div className="subscriptions-list">
            {pricePlans.map(role => (
                <SubscriptionCard
                    key={role.productClassCode}
                    role={role}
                    productType={productType || ''}
                    isCurrentSubscription={
                        productType === role.productClassCode
                    }
                />
            ))}
        </div>
    );
};

export default ManageSubscription;
